module.exports = __webpack_public_path__ + "static/media/xya_pfaendleri.29bb70cf.jpg";